<div fxLayout="row wrap" fxLayoutAlign="center center" class="layout-wrapper">
  <div fxFlex="100%" class="flex-wrapper">
    <alert></alert>
    <ng-content></ng-content>
  </div>
</div>